import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M5 21.75A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v5a.75.75 0 0 1-1.5 0V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h5a.75.75 0 0 1 0 1.5H5Z"
    />
    <path
      fill="#F7A600"
      d="M14 8.25a5.75 5.75 0 1 0 3.501 10.312l1.969 1.968a.75.75 0 1 0 1.06-1.06L18.562 17.5A5.75 5.75 0 0 0 14 8.25ZM9.75 14a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0Z"
    />
  </svg>
);
export default SvgTwoColorSearch;
